import {CSSProperties} from "react";

interface IAvatarIcon {
    style?: CSSProperties
}

export function AvatarIcon({style}: IAvatarIcon) {
    return (
        <svg viewBox="0 0 32 32" fill="none" style={style}>
            <circle cx="16" cy="11" r="6" fill="currentColor"/>
            <path d="M4 28 Q4 19 16 19 Q28 19 28 28 Z" fill="currentColor"/>
        </svg>
    );
}
